import { LocationTypeEnum } from '@varo/graphql-schema-types';
import {
  DepositLocation,
  WithdrawalLocation,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const locationsQuery = gql`
  query GetLocations($latitude: Float!, $longitude: Float!) {
    __typename
    locations(
      input: {
        coordinate: { latitude: $latitude, longitude: $longitude }
        types: [WITHDRAWAL, DEPOSIT]
      }
    ) {
      ...DepositLocation
      ...WithdrawalLocation
    }
  }
  ${DepositLocation}
  ${WithdrawalLocation}
`;

const depositLocationsQuery = gql`
  query GetDepositLocations($latitude: Float!, $longitude: Float!) {
    __typename
    depositLocations(
      input: { coordinate: { latitude: $latitude, longitude: $longitude } }
    ) {
      ...DepositLocation
    }
  }
  ${DepositLocation}
`;

const withdrawalLocationsQuery = gql`
  query GetWithdrawalLocations($latitude: Float!, $longitude: Float!) {
    __typename
    withdrawalLocations(
      input: { coordinate: { latitude: $latitude, longitude: $longitude } }
    ) {
      ...WithdrawalLocation
    }
  }
  ${WithdrawalLocation}
`;

const gqlQuery = (AtmType?: LocationTypeEnum) => {
  switch (AtmType) {
    case LocationTypeEnum.Deposit:
      return depositLocationsQuery;
    case LocationTypeEnum.Withdrawal:
      return withdrawalLocationsQuery;
    // No input for query will return all ATMs
    default:
      return locationsQuery;
  }
};

export default gqlQuery;
